<div style="flex: auto; display: flex">
    <div style="flex: auto;">
        <a ng-click="$ctrl.viewDetails()">{{ $ctrl.item.text }}</a><br>
        <span style="font-style: italic;font-size: 90%">{{ $ctrl.item.path }}</span>
        <br ng-if="$ctrl.item.description.length>0"><span style="font-style: italic;font-size: 90%">{{ $ctrl.item.description }}</span>
    </div>
    <span ng-if="$ctrl.item.isEditable" ng-click="$ctrl.removeItem()" style="flex: 0 1 11px;" class="fa fa-times hover-effects"></span>
</div>
<ul class="workflow-property-list">
    <li ng-repeat="prop in $ctrl.item.formValues">
        <span ng-bind-html="prop.name"></span>
    </li>
</ul>